import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);
const ADMIN_TOKEN_KEY = "la_admin_token";

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, object = user
  const [loading, setLoading] = useState(true);
  const [impersonating, setImpersonating] = useState(!!localStorage.getItem(ADMIN_TOKEN_KEY));

  const refresh = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  const loginWithToken = async (token) => {
    const { data } = await api.post("/auth/verify", { token });
    localStorage.setItem("la_token", data.access_token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("la_token");
    localStorage.removeItem(ADMIN_TOKEN_KEY);
    setImpersonating(false);
    setUser(false);
  };

  // Admin bekijkt een andere gebruiker: bewaar de admin-token apart en wissel.
  const impersonate = (token, impersonatedUser) => {
    const current = localStorage.getItem("la_token");
    if (current) localStorage.setItem(ADMIN_TOKEN_KEY, current);
    localStorage.setItem("la_token", token);
    setImpersonating(true);
    setUser(impersonatedUser);
  };

  const stopImpersonating = async () => {
    const adminToken = localStorage.getItem(ADMIN_TOKEN_KEY);
    if (adminToken) {
      localStorage.setItem("la_token", adminToken);
      localStorage.removeItem(ADMIN_TOKEN_KEY);
    }
    setImpersonating(false);
    await refresh();
  };

  return (
    <AuthContext.Provider value={{ user, loading, setUser, refresh, loginWithToken, logout, impersonate, stopImpersonating, impersonating }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);

export function roleHome(role) {
  if (role === "child") return "/leerling";
  if (role === "parent") return "/ouder";
  if (role === "admin") return "/admin";
  return "/";
}
